import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_MediaCards = _resolveComponent("MediaCards")!
  const _component_table_list = _resolveComponent("table-list")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MediaCards, {
      ref: "mediaCardRef",
      type: [
      {
        name: 'textInputCard',
        props: {
          text: _ctx.text,
        },
        event: {
          changeText: _ctx.onChangeText,
        },
      },
      {
        name: 'scenario',
        props: {
          scenarioUrl: _ctx.scenarioUrl,
          title: 'Scenario',
          description: '** Last selected scenario is saved.',
        },
        event: {
          click: _ctx.onClick,
        },
      },
    ]
    }, {
      guide: _withCtx(() => [
        _createVNode(_component_a_typography_title, { level: 5 })
      ]),
      _: 1
    }, 8, ["type"]),
    _createVNode(_component_table_list, {
      ref: "tableListRef",
      columns: _ctx.columns,
      "list-columns": [
      {
        title: 'Made by',
        key: 'username',
      },
    ],
      apis: { list: `audio-results/tts` },
      type: "audio",
      "table-handler-props": { mode: ['download'] }
    }, null, 8, ["columns"])
  ], 64))
}